import { Home } from '../pages/Home';
import { Route } from '../types';

export const routes: Route[] = [
  {
    path: '/',
    element: <Home />
  }
];
